import React from "react";
import { Observer } from "mobx-react";
import GroupHeadline from "@components/GroupHeadline";
import { AccommodationCard } from "../AccommodationCard/AccommodationCard";
import { AccommodationSearchActionBar } from "./AccommodationSearchActionBar";
import { AccommodationSearchStore } from "./AccommodationSearchStore";
import SearchResultLayout from "@search/components/SearchResultLayout";
import SearchPageLayout from "@search/components/SearchPageLayout";
import { CellMeasurer, ListRowProps } from "react-virtualized";
import CardSearch from "@search/CardSearch/CardSearch";
import AccommodationSearchForm from "./AccommodationSearchForm";
import { ClearSearch } from "@search";

type Props = {
  onOpen: (id: string) => any;
  onNewItem: () => any;
};

class AccommodationSearch extends React.Component<Props> {
  localStore = new AccommodationSearchStore({ initialFilter: { text: "" } });

  renderRow = (params: ListRowProps) => {
    const { index, parent, style } = params;

    let content;
    const row = this.localStore.searchManager.items[index];

    if (row.type === "group") {
      content = (
        <GroupHeadline fitted mainText={row.header.city} smallText={row.header.country} />
      );
    }

    if (row.type === "card") {
      content = (
        <AccommodationCard
          data={row.data}
          // highlightSearch={text.trim()}
          onClick={() => this.props.onOpen(row.data._id)}
        />
      );
    }

    return (
      <CellMeasurer
        key={row._id}
        cache={this.localStore.cellMeasurerCache}
        parent={parent}
        columnIndex={0}
        rowIndex={index}
      >
        <div style={{ ...style, padding: 8 }}>{content}</div>
      </CellMeasurer>
    );
  };

  renderContent = (scrollContainer: HTMLElement) => {
    return (
      <CardSearch
        cellMeasurerCache={this.localStore.cellMeasurerCache}
        manager={this.localStore.searchManager}
        renderRow={this.renderRow}
        scrollContainer={scrollContainer}
        onRowsRendered={this.localStore.searchManager.onRowsRendered}
      />
    );
  };

  renderGroupHeadline = () => {
    return (
      <Observer>
        {() => (
          <div style={{ position: "sticky", top: 0, zIndex: 1, padding: "0 8px 16px" }}>
            {this.localStore.searchManager.header && (
              <GroupHeadline
                fitted
                mainText={this.localStore.searchManager.header.city}
                smallText={this.localStore.searchManager.header.country}
              />
            )}
          </div>
        )}
      </Observer>
    );
  };
  renderFilter = () => {
    return (
      <>
        <ClearSearch onClick={this.localStore.filterManager.clearFilter} />
        <AccommodationSearchForm manager={this.localStore.filterManager} />
      </>
    );
  };

  render() {
    return (
      <Observer>
        {() => (
          <SearchPageLayout
            delayed
            stickyContainerProps={
              {
                // offsetTop: 48
              }
            }
            actionBar={
              <>
                <AccommodationSearchActionBar
                  onNew={this.props.onNewItem}
                  total={this.localStore.total}
                  // sortOptions={sortOptions}
                />
                {/*<SearchOptions*/}
                {/*  activeGroupBy="week"*/}
                {/*  groupBy={groupBy}*/}
                {/*  onGroupBy={v =>*/}
                {/*    this.props.onGroupBy(v.value, toJS(this.store.filterManager.filter))*/}
                {/*  }*/}
                {/*/>*/}
              </>
            }
            content={(scrollContainer) => (
              <SearchResultLayout fittedContent>
                {this.renderGroupHeadline()}
                {this.renderContent(scrollContainer)}
              </SearchResultLayout>
            )}
            filter={this.renderFilter()}
          />
        )}
      </Observer>
    );
  }
}

export default AccommodationSearch;
